import { makeStyles } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import pointer from '../images/pointer.png';

const useProductStyles = makeStyles((theme) => ({
  productDescriptionContainer: {
    paddingTop: 130,
    backgroundColor: grey[100],
    minHeight: 'calc(100vh)',
  },
  link: {
    textDecoration: 'underline',
    color: theme.palette.text.secondary,
    cursor: `url(${pointer}), auto`,
  },
  variantsContainer: {
    backgroundColor: grey[200],
  },
  chip: {
    cursor: `url(${pointer}), auto`,

    '&.MuiChip-colorSecondary': {
      cursor: `url(${pointer}), auto`,
      color: 'white',
      backgroundColor: theme.palette.error.dark,
    },
  },
  price: {
    textDecoration: 'line-through',
    color: theme.motorX.darkGray,
  },
}));

export default useProductStyles;
